import React from 'react'
import Radio from '@components/Radio/Radio'
import { OrusLogo } from '@assets/svg'
import Button from '@components/Button'

interface RadioCardProps {
  selected: boolean
  onClick?: React.DOMAttributes<HTMLButtonElement>['onClick']
  children: React.ReactNode
}

interface Props {
  selected?: boolean
  setSelected: (value: boolean) => void
  singleButton?: boolean
}

const RadioCard = ({ selected, onClick, children }: RadioCardProps) => {
  const color = selected ? 'black' : 'border-verylight-gray'

  return (
    <div className={`md:basis-1/2 flex text-center py-6 px-12 rounded-lg border-1 border-${color} mb-3 cursor-pointer relative`} onClick={onClick}>
      <div className="absolute top-3 right-3">
        <Radio selected={selected} />
      </div>
      {children}
    </div>
  )
}

const OrusForm = ({ selected, setSelected, singleButton }: Props) => {
  return (
    <div className="">
      <OrusLogo className="mx-auto mb-3 h-[26px] w-auto" />
      <h2 className="[&&]:text-base [&&]:text-center [&&]:p-0 mb-4">Orus, l’assurance pro préférée des français</h2>
      <div className="bg-new-verylight-gray border-verylight-gray border-1 rounded-lg flex pl-3 pr-4 py-4 mb-8">
        <div className="h-5 w-5 mr-2 shrink-0 text-sm items-baseline">💡</div>
        <div className="text-sm text-left items-baseline italic">Chez Ma Domiciliation.fr nous savons combien il est important d’être bien assuré, mais aussi, et surtout, de bénéficier d’un service client de qualité et humain. C’est pourquoi on recommande fortement Orus, l’assurance pro la mieux notée de France, avec 4.9/5 sur Trustpilot !</div>
      </div>
      <ul className="text-left text-sm mb-8 ml-[30px] [&&]:list-[circle]">
        <li>+ 50 000 professionnels assurés</li>
        <li>Un devis en 3 min</li>
        <li>Des conseillers disponibles par téléphone, whatsapp et email</li>
        <li>RC Pro, Décennale, Multirisque Professionnelle, Mutuelle</li>
        <li>Une RC Pro sans engagement, sans franchise, avec protection juridique incluse</li>
        <li>À partir de 13€ / mois</li>
      </ul>
      {singleButton ? 
        (
          <div className="flex flex-col md:flex-row gap-3">
            <Button
              onClick={() => setSelected(true)}
              className='max-w-[300px] mx-auto'
            >
              Je souhaite être contacté
            </Button>
          </div>
        ) : (
        <div className="flex flex-col md:flex-row gap-3">
          <RadioCard
            selected={selected}
            onClick={() => setSelected(true)}
          >
            <div className="text-center">
              <div className="text-sm">Oui, je souhaite être contacté par un conseiller Orus</div>
            </div>
          </RadioCard>
          <RadioCard
            selected={!selected}
            onClick={() => setSelected(false)}
          >
            <div className="text-center mx-auto">
              <div className="text-sm">Non, j'ai déjà une assurance professionnelle</div>
            </div>
          </RadioCard>
        </div>
      )}
    </div>
  )
}

export default OrusForm